import React, { useState, lazy, Suspense } from 'react';
import './Comments.css';
import back from "../../images/icons/left-backarrow.svg";

const Messages = lazy(() => import("./Messages"));
const CommentsButton = lazy(() => import("./CommentsButton"));

/*************  ✨ Windsurf Command ⭐  *************/
/**
 * A component to show a comment button and comments panel based on the given "from" and "id".

/*******  97ae4988-9734-4259-9f78-9a7c086fcd31  *******/
const CommnetContatiner = ({ from, id, addUsers , permissions }) => {
  const [open, setOpen] = useState(false);

  
  const toggleComments = () => {
    setOpen(!open);
  };

  return (
    <div className="comments-wrapper">
      {!open && <Suspense fallback={<div></div>}><CommentsButton toggle={toggleComments} /></Suspense>}
      {open && (
        <div className="comments-panel">
          <div className="comments-header">
            <button className="comments-back-button" onClick={toggleComments}>
              <img src={back} alt="Back Arrow" />
            </button>
            <span>Comments</span>
          </div>
          <Suspense fallback={<div></div>}>
            <Messages from={from} id={id} addUsers={addUsers} permissions={permissions} />
          </Suspense>
        </div>
      )}
    </div>
  );
};

export default CommnetContatiner;
